/**
 * PWA Management Module
 * Handles installation prompt and lifecycle
 */

let deferredPrompt;
const installBtn = document.getElementById('pwa-install-btn');

export function initPWA() {
    window.addEventListener('beforeinstallprompt', (e) => {
        // Prevent Chrome 67 and earlier from automatically showing the prompt
        e.preventDefault();
        // Stash the event so it can be triggered later.
        deferredPrompt = e;
        // Update UI to notify the user they can add to home screen
        if (installBtn) {
            installBtn.classList.remove('hidden');
        }
        console.log('PWA install prompt captured');
    });

    if (installBtn) {
        installBtn.addEventListener('click', async () => {
            if (deferredPrompt) {
                // Show the prompt
                deferredPrompt.prompt();
                // Wait for the user to respond to the prompt
                const { outcome } = await deferredPrompt.userChoice;
                console.log(`User response to the install prompt: ${outcome}`);
                // We've used the prompt, clear it
                deferredPrompt = null;
                installBtn.classList.add('hidden');
            }
        });
    }

    window.addEventListener('appinstalled', () => {
        console.log('PWA was installed');
        if (installBtn) installBtn.classList.add('hidden');
        deferredPrompt = null;
    });
}
